import sdl from '@jds/react-generated-sdl/JDSHorizontalStepper';
import type { JDSHorizontalStepperProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, StepperProps, type StepperRef } from '../logic';

const Component = (props: StepperProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { custom = '', ...rest } = props as any;
  return createComponent(
    json,
    rest,
    'JDSHorizontalStepper',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const HorizontalStepper = withLogic(
  Component
) as React.ForwardRefExoticComponent<
  StepperProps & React.RefAttributes<StepperRef>
> & { slotName?: string };

HorizontalStepper.displayName = 'HorizontalStepper';
HorizontalStepper.slotName = 'jds_horizontal_stepper';

export { HorizontalStepper, type JDSHorizontalStepperProps };
